var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"d-none d-lg-block"},[_c('b-col',[_c('app-bread-crumbs',{attrs:{"routes":[
          { name: 'home', title: 'Accueil' },
          { name: 'reportNew', title: 'Mon parcours' },
        ]}})],1)],1),_c('app-admin-who-are-we',{staticClass:"d-none d-lg-block"}),(_vm.$mq !== 'md')?_c('app-report-steps'):_vm._e(),(_vm.$mq === 'md')?_c('app-report-steps-mobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }